<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
	currentArticle: {
		type: Object,
		required: true,
	},
	localizedUrl: {
		type: String,
		required: true,
	},
	isRead: {
		type: Boolean,
		default: false,
	},
	isArticleInverted: {
		type: Boolean,
		required: true,
	},
	isLanguageModalOpen: {
		type: Boolean,
		required: true,
	},
	windowWidth: {
		type: Number,
		required: true,
	},
	invertArticle: {
		type: Function,
		required: true,
	},
	reportArticle: {
		type: Function,
		required: true,
	},
	tagEvent: {
		type: Function,
		required: true,
	},
	toggleModals: {
		type: Function,
		required: true,
	},
	handleArticleAction: {
		type: Function,
		required: true,
	},
});

function refreshArticle() {
	document.getElementById('iframe').src = props.localizedUrl;
}
</script>

<template>
<div id="overview-control-bar">
	<div v-if="!isRead" class="unread-badge">
		<i class="fa-solid fa-circle" aria-hidden="true"></i>
		<span>Unread</span>
	</div>
	<a
		id="translate" class="btn" title="Translate"
		@click="toggleModals('language-prompt')"
	>
		<svg width="28" height="20" viewBox="0 0 387 275" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M247 240L261.606 202M366.5 240L352.725 202M261.606 202L301.774 97.4986C304.098 91.4521 312.681 91.5346 314.889 97.6245L352.725 202M261.606 202H352.725" stroke="var(--bg1)" stroke-width="41" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M247 240L261.606 202M366.5 240L352.725 202M261.606 202L301.774 97.4986C304.098 91.4521 312.681 91.5346 314.889 97.6245L352.725 202M261.606 202H352.725" stroke="var(--text1)" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M21 39H108M188 39H160.5M160.5 39C153 91 117.5 149.5 39.5 182M160.5 39H108M60 87.5C80.5 139.5 135 170.5 165.5 182M108 39V21" stroke="var(--bg1)" stroke-width="41" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M21 39H108M188 39H160.5M160.5 39C153 91 117.5 149.5 39.5 182M160.5 39H108M60 87.5C80.5 139.5 135 170.5 165.5 182M108 39V21" stroke="var(--text1)" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M281 10L180 265" stroke="var(--link)" stroke-width="20" stroke-linecap="round"/>
		</svg>
	</a>
	<template v-if="windowWidth >= 1024">
		<a
			id="report"
			class="btn"
			title="Report issue"
			v-if="currentArticle?.url"
			@click.stop="reportArticle()"
		>
			<i class="fa-solid fa-triangle-exclamation" aria-label="Report issue"></i>
		</a>
		<a
			id="invert"
			:class="['btn toggle', {active: isArticleInverted}]"
			title="Invert article"
			v-if="currentArticle?.embed || currentArticle.privacy"
			@click="invertArticle()"
		>
			<i class="fa-solid fa-eclipse" aria-label="Invert article"></i>
		</a>
		<a
			id="refresh"
			class="btn"
			title="Reload article"
			v-if="currentArticle?.embed || currentArticle.privacy"
			@click.stop="refreshArticle()"
		>
			<i class="fa-solid fa-rotate" aria-label="Reload article"></i>
		</a>
		<a
			id="pop-out"
			class="btn"
			title="Open article in new window"
			target="_blank"
			:href="localizedUrl"
			v-if="windowWidth >= 1024"
			@click.stop="handleArticleAction('read', undefined, currentArticle?.id)"
		>
			<i class="fa-solid fa-browsers" aria-label="Open article in new window"></i>
		</a>
	</template>
</div>
</template>

<style lang="scss" scoped>
#overview-control-bar {
	/* unread-badge, report issue, refresh, pop-out */
	display: flex;
	justify-content: flex-end;
	gap: 4px;

	&:has(div) { min-height: 38px; }
}

.unread-badge {
	border-radius: 14px;
	color: var(--link);
	display: inline-flex;
	align-items: center;
	justify-content: space-evenly;
	gap: 4px;
	margin-right: auto;
	i {font-size: .5em;}
}

#report {display: none;} /* not yet implemented */
#translate {padding: 8px 6px;}
</style>
